module.exports = __webpack_public_path__ + "static/media/production (1).3c492791.svg";